import React, { useContext } from 'react';
import {
  QuestionCheckbox,
  QuestionCurrency,
  QuestionDate,
  QuestionDependentDropdown,
  QuestionDropdown,
  QuestionMonth,
  QuestionNumber,
  QuestionPercent,
  QuestionWithAttachments,
  QuestionRadioButton,
  QuestionRelation,
  QuestionSmileyRating,
  QuestionStarRating,
  QuestionTable,
  QuestionText,
  QuestionTime,
  QuestionYear,
} from 'src/components/JobDatasheet';
import JobDatasheetLanguageContext from 'src/components/JobDatasheet/context/JobDatasheetLanguageContext';
import s from './PublicSurveyIntro.styles';

const questionTypeMapping = {
  // autofill: QuestionAutofill,
  checkbox: QuestionCheckbox,
  currency: QuestionCurrency,
  date: QuestionDate,
  dropdown: QuestionDropdown,
  dependentDropdown: QuestionDependentDropdown,
  // file: QuestionFile,
  month: QuestionMonth,
  number: QuestionNumber,
  percent: QuestionPercent,
  picture: QuestionWithAttachments,
  radioButton: QuestionRadioButton,
  relation: QuestionRelation,
  smileyRating: QuestionSmileyRating,
  starRating: QuestionStarRating,
  table: QuestionTable,
  text: QuestionText,
  time: QuestionTime,
  voice: QuestionWithAttachments,
  year: QuestionYear,
};

const PublicSurveyQuestion = (props) => {
  const {
    allQuestions,
    question,
    questionIndex,
    currentActiveQuestionIndex,
    getQuestionResult,
    setQuestionResult,
    questionResultsMap,
    disableChange
  } = props;

  const { questionType, fileUrl } = question;

  const { selectedLanguage } = useContext(JobDatasheetLanguageContext);

  const QuestionTypeForm = questionTypeMapping[questionType];
  if (!QuestionTypeForm) {
    return null;
  }

  if (currentActiveQuestionIndex !== questionIndex) {
    return null;
  }

  let questionText = question.text;
  if (selectedLanguage) {
    const questionTranslation = (question.translations || []).find(c => c.languageId === selectedLanguage);
    questionText = questionTranslation?.text || questionText;
  }

  const questionIsMandatory = (question.validations || []).some(validation => validation.rule.toLowerCase().replace(/\s+/g, '') === 'this!=null');

  const getQuestionText = () => (
    <p>
      {questionIsMandatory && <s.RedFont>* </s.RedFont>}
      <s.QuestionNumber>{question.questionNumber}.</s.QuestionNumber>
      {questionText}
    </p>
  );

  const onAudioPlaying = (e) =>{
    const audios = document.getElementsByTagName('audio');
    /*  eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }]  */
    for (let i = 0, len = audios.length; i < len; i++) {
        if (audios[i] !== e.target) {
            audios[i].pause();
        }
    }

  }
  return (
    <div>
      { (fileUrl && questionType === 'voice') ? <s.AudioAttachment>
          { getQuestionText() }
          <audio src={fileUrl} controls onPlaying={onAudioPlaying}></audio>
        </s.AudioAttachment> : 
        getQuestionText()
      }
      { (fileUrl && questionType === 'picture') && <s.PictureAttachment>
          <img src={fileUrl} />
        </s.PictureAttachment>
      }
      <QuestionTypeForm
        allQuestions={allQuestions}
        allowSearch={false}
        getResult={getQuestionResult}
        onChange={(value)=>setQuestionResult(value,question.datasheetQuestionId)}
        question={question}
        value={questionResultsMap.get(question.datasheetQuestionId) || null}
        fromSurveyExecution={true}
        disableChange={disableChange}
      />
    </div>
  );
};

export default React.memo(PublicSurveyQuestion);
